var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFavorites(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269,
    height: 151.728,
    viewBox: "0 0 269 151.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.d{fill:#fff;}.c{fill:#c8d1ec;}.d{stroke:#c8d1ec;stroke-width:2px;}.e{fill:#c8d1ec;}.f{stroke:none;}.g{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.904 -208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 158,
    height: 35,
    rx: 17,
    transform: "translate(111.904 306.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 103,
    height: 36,
    rx: 17,
    transform: "translate(272.904 270.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 105,
    height: 35,
    rx: 17,
    transform: "translate(275.904 324.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,105V89.251H14.086V0H73.954V89.251H81V105Z",
    transform: "translate(216.904 218.728)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.343 208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M141.217,118.832h-75.5a6.048,6.048,0,0,1-6.076-6.006V103.8a.471.471,0,0,1,0-.069v-.069a6.071,6.071,0,0,1,6.069-5.868H67.59a6.026,6.026,0,0,1,0-.858V57.2A18.091,18.091,0,0,0,55.37,79.682c2.691,10.3,3.342,24.9-3.678,32.157a14.126,14.126,0,0,1-9.988,4.089c-.14,0-.276,0-.415-.006a23.774,23.774,0,0,1-5.358-.65,17.32,17.32,0,0,1-12.948-9.749C16.489,90.7,31.039,65.409,31.662,64.34a56.407,56.407,0,0,0,6.471-13.986C40.3,43.269,41.6,33.211,35.516,25.527l-3.783,4.7a6.11,6.11,0,0,1-4.062,2.231H27.12a6.062,6.062,0,0,1-3.752-1.3L10.314,20.86l-.065-.049-.065-.05a5.976,5.976,0,0,1-.912-8.448l3.889-4.63A18.986,18.986,0,0,0,4.18,5.419c-.39,0-.768.011-1.123.033a2.437,2.437,0,0,1-.347.023A2.707,2.707,0,0,1,.023,3.135a2.686,2.686,0,0,1,2.341-3A16.1,16.1,0,0,1,4.422,0c5.887,0,12.947,3.009,20.984,8.943a95,95,0,0,1,11.257,9.825l.034.033a25.1,25.1,0,0,1,8.325,14.643,36.469,36.469,0,0,1-.868,15.415,63.443,63.443,0,0,1-7.876,17.989c0,.006-.03.057-.071.129-2.256,4.061-13.257,24.9-8.223,36.384a12.056,12.056,0,0,0,9.128,6.864,10.9,10.9,0,0,0,10.9-2.026c5.184-5.223,4.858-17.785,2.361-27.246A23.614,23.614,0,0,1,67.658,51.779V7.168a6.048,6.048,0,0,1,6.076-6.006h59.358a6.048,6.048,0,0,1,6.076,6.006V96.935a6.018,6.018,0,0,1,0,.858h2.048a6.048,6.048,0,0,1,6.076,6.006v9.026A6.048,6.048,0,0,1,141.217,118.832Zm-75.361-15.89a.864.864,0,0,0-.867.858v9.026a.864.864,0,0,0,.867.858h75.5a.864.864,0,0,0,.867-.858V103.8a1.094,1.094,0,0,0-.01-.148.861.861,0,0,0-.857-.719,1.028,1.028,0,0,0-.139.01ZM89.564,71.788a2.574,2.574,0,1,0,0,5.148h27.771a2.574,2.574,0,1,0,0-5.148Zm-4.13-57.311a6.048,6.048,0,0,0-6.076,6.006V56.073a6.047,6.047,0,0,0,6.076,6H121.4a6.045,6.045,0,0,0,6.073-6V20.484a6.047,6.047,0,0,0-6.073-6.006ZM17.955,10.627a.6.6,0,0,0-.109.007.852.852,0,0,0-.589.31L13.4,15.679a.846.846,0,0,0,0,1.2L26.457,27.173a.833.833,0,0,0,.514.178.6.6,0,0,0,.109-.007.874.874,0,0,0,.592-.307l3.851-4.7a.835.835,0,0,0,.313-.653.821.821,0,0,0-.313-.581L18.472,10.8A.84.84,0,0,0,17.955,10.627Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.78,5.223a7.617,7.617,0,0,1,10.787,0l1.447,1.492,1.492-1.492A7.627,7.627,0,0,1,28.271,16.03L26.8,17.477,16.014,28.239,5.273,17.477,3.78,16.03A7.682,7.682,0,0,1,3.78,5.223Z",
    transform: "translate(87.515 25.317)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(311.904 230.728)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 8,
    cy: 9,
    rx: 8,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 8,
    cy: 9,
    rx: 7,
    ry: 8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(335.904 221.728)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(153.904 311.728)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.5,
    cy: 7.5,
    r: 6.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(146.904 296.728)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 4,
    cy: 3,
    rx: 4,
    ry: 3,
    transform: "translate(312.904 215.728)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavorites);
export default __webpack_public_path__ + "static/media/no_favorites.265b5a5deafdf8a900ed941d975c2b5f.svg";
export { ForwardRef as ReactComponent };